import { absolutePath } from "./absolutePath";

export const site = {
  pages: {
    show: (id: number) => absolutePath(`site/pages/${id}`),

    passwordAttempt: {
      create: ({ pageId }: { pageId: number }) =>
        absolutePath(`site/pages/${pageId}/password_attempt`),
    },
  },
};
